/* global femcare, Swiper */

femcare.shared.slider = {
    init() {
        const sliders = document.querySelectorAll('.slider');

        if (sliders.length) {
            sliders.forEach(slider => {
                const slideCountEl = slider.querySelector('.slider__slide-count');
                const pageLocalized = slideCountEl?.getAttribute('data-page-local') || '';
                const ofLocalized = slideCountEl?.getAttribute('data-of-local') || ' / ';

                new Swiper(slider.querySelector('.swiper'), {
                    lazy: false,
                    watchOverflow: true,
                    breakpoints: {
                        350: {
                            slidesPerView: 2,
                            slidesPerGroup: 2
                        },
                        600: {
                            slidesPerView: 3,
                            slidesPerGroup: 3
                        },
                        1200: {
                            slidesPerView: 4,
                            slidesPerGroup: 4
                        }
                    },
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                        type: 'custom',
                        renderCustom: (swiper, current, total) =>
                            total === 1 ? '' : `${pageLocalized} ${current} ${ofLocalized} ${total}`
                    },
                    navigation: {
                        nextEl: slider.querySelector('.slider__next'),
                        prevEl: slider.querySelector('.slider__previous')
                    }
                });
            });
        }
    }
};
